module.exports = __webpack_public_path__ + "img/1.41975e76.jpeg";